export default __webpack_public_path__ + "static/polaroid-frame-149aab61499e3a6efe92b60ece12d46e.png";